<template>
	<Modal v-model:visible="visible" :title="$t('settings.vrsSettingsForm.pppRtk.cnetUpdateForm.header')" width="80vw">
		<CNetListTable :subNetworkId="subNetworkId" :onUpdate="onUpdate"/>
		<template #footer>
			<Button key="back" @click="onCancel">{{ $t('settings.vrsSettingsForm.pppRtk.cnetUpdateForm.cancelButtonLabel') }}</Button>
		</template>
	</Modal>
</template>

<script>
import { computed } from 'vue';
import { Modal, Button } from 'ant-design-vue';

import CNetListTable from '@/components/top_level/CNetListTable.vue';

export default {
	components: {
		Modal, Button, CNetListTable,
	},
	props: {
		modelValue: Boolean,
		fetchSettings: Function,
		subNetworkId: Number,
	},
	emits: ['update:modelValue'],
	setup(props, { emit }) {
		const visible = computed({
			get: () => props.modelValue,
			set: (value) => emit('update:modelValue', value),
		});

		const onCancel = () => {
			visible.value = false;
		};

		const onUpdate = () => {
			props.fetchSettings();
			onCancel();
		};

		return {
			visible,
			onCancel,
			onUpdate,
		};
	},
};
</script>
